import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { setAuthData,removeFilter,setInsightFunction } from '../../src/actions/index'
import { bindActionCreators } from 'redux';
import { getParameterByName } from './commonComponents/Helper';

const AdminSideBar = ({ authData, menuOptions,removeFilter ,setInsightFunction,data}) => {
    const [menuData, setmenuData] = useState({})
    const [mobile, setMobile] = useState(window.screen_width < 992)

    let selected_page = window.location.pathname;
    useEffect(() => {
        setmenuData(menuOptions)
        const handleResize = () => {
            setMobile(window.innerWidth < 992);
        };
    
        window.addEventListener('resize', handleResize);
        setTimeout(() => {
            feather.replace()
            asideBody = new PerfectScrollbar('.aside-body', {
                suppressScrollX: true
            });
            if ($('.aside-backdrop').length === 0) {
                $('body').append('<div class="aside-backdrop"></div>');
            }
            if(mobile){
                $('body').on('click', '.aside-backdrop', function (e) {
                    $('body').removeClass('show-aside');
                })
            }
            // if (selected_page.split('/')[1] == 'admin') {
            //     $('.nav-aside .with-sub').off('click');
            //     $('.nav-aside .with-sub').on('click', '.nav-link', function (e) {
            //         e.preventDefault();
            //         $(this).parent().siblings().removeClass('show');
            //         $(this).parent().toggleClass('show');
            //         asideBody.update()
            //     })
            // }
        }, 1000);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [JSON.stringify(menuOptions), mobile])
    const handleSubmenu = (key,e) => {
        e.preventDefault();
        let element = document.querySelectorAll(`[subKey="${key}"]`);
        // Log the element to verify it's being selected
        element[0].classList.toggle("show");
    }
    const handleLogout = () => {
        // if (window.localStorage.getItem('Cookies') !== null) {
        //     let cookie = JSON.parse(window.localStorage.getItem('Cookies'));
        //     let data = {
        //         refresh_token: cookie['refreshToken'],
        //         companyName: cookie['realm']
        //     }
        //     let url = '/logout';
        //     window.localStorage.clear();
        //     CallAPI('post', url, data, null, 0, function (response) {
        //     });
        // }

    }

    let firstname = authData.firstName;
    let lastname = authData.lastName;
   
    let username = firstname && lastname ? `${(firstname.charAt(0).toUpperCase())}${firstname.slice(1)} ${lastname.charAt(0).toUpperCase()}${lastname.slice(1)}` : 'Demo';
    let navigation_content = '';

    navigation_content = Object.values(menuData).map((element, i) => {

        let active_class = "";
        // if (element.link.split('?')[0] == selected_page  )
        //     active_class = "active";

        let menu_element = (<li id={`nav_${element["label"]}`} className={`nav-item ${active_class}`} key={`nav_${element["label"]}_${i}`}>
            <Link className={`nav-link`} to={element["link"]}>
                <i className="feather" data-feather={element["icon"] ? element["icon"] : null}></i>
                <span>{element["label"]}</span>
            </Link>
        </li>);
let isAdmin = window.location.pathname.includes('admin')
        if (element["children"]) {
            let innerElement = [];
            innerElement = Object.values(element["children"]).map((innerData) => {
                return (
                    <li id={`nav_${innerData["label"]}`} key={`nav_${innerData["label"]}_${i}`} >
                        <Link to={innerData["link"]}>
                            <span>{innerData["label"]}</span>
                        </Link>
                    </li>
                );
            });

            menu_element = <li id={`nav_${element["label"]}`} className="nav-item with-sub" subKey={`nav_${element["label"]}_${i}`} key={`nav_${element["label"]}_${i}`} onClick={(e) => { isAdmin ? handleSubmenu(`nav_${element["label"]}_${i}`, e) : null }}>
                <a href={`${element["link"]}`} className="nav-link" style={{ cursor: "pointer" }}>
                    <i className="feather" data-feather={element["icon"] ? element["icon"] : null}></i>
                    <span>{element.label}</span>
                </a>
                <ul>
                    {innerElement}
                </ul>
            </li>
        }
        return menu_element;
    });

    const closeMenus = () => {
        if (mobile) {
            calendarDropDown("close");
            if (data.filter == true || data.filter == "[]") {
                defaultFilterFlag = '0'
                removeFilter();
            }
            if (data.insight == true) {
                var temp_url = location.pathname.split('/');
                temp_url = temp_url[temp_url.length - 1];
                setInsightFunction({ "point": null, "insight": false })
            }
            if (mobile) {
                jQuery('body').toggleClass('show-aside');
            }
        }else{
            jQuery("#side_navbar").toggleClass('minimize');
        }
    }
    var extraInfo = authData ? (authData.extraInfo ? JSON.parse(authData.extraInfo) : null) : null;
    logo = extraInfo ? (extraInfo.logo ? extraInfo.logo : logo) : logo
    let logoIMG = logo ? `/assets/images/logos/${logo}-fav.png` : `/assets/images/logos/rockmetric-fav.png`;
    return (
        <aside className={`aside aside-fixed ${mobile ? '': window.innerWidth < 1197 ? 'minimize' : 'minimize'}`} id="side_navbar" style={{zIndex:"1002"}}>
            <div className="aside-header" onClick={closeMenus}>
                <a href="/" className="aside-logo">{authData.companyName.toLowerCase() === "sbigic" || authData.companyName.toLowerCase() === "sbig" || authData.companyName.toLowerCase() === "sbi" ? "SBI General" : authData.companyName.split(" ")[0]}</a>
                <a href="javascipt:avoid(0)" className="aside-menu-link">
                    <i data-feather="menu"></i>
                    <i data-feather="x"></i>
                </a>
            </div>
            <div className="aside-body">
                <div className="aside-loggedin">
                    {authData && authData.companyName !== 'sbi'
                        ? <><div className="d-flex align-items-center justify-content-start">
                            <a href="#" className="avatar">
                                <img src={logoIMG} id="sideBarImg" className="rounded-circle" alt="" />
                            </a>
                            <div className="aside-alert-link">
                            </div>
                        </div></>
                        : null}
                    <div className="aside-loggedin-user">
                        <a href="#loggedinMenu" className="d-flex align-items-center justify-content-between mg-b-2" data-toggle="collapse">
                            <h6 className="tx-semibold mg-b-0">{username}</h6>
                        </a>
                    </div>


                    <div className="collapse" id="loggedinMenu">
                        <ul className="nav nav-aside mg-b-0">
                        </ul>
                    </div>

                    <ul className="nav nav-aside">
                        {navigation_content}
                        <li id="logoutLink" className={`nav-item`} onClick={handleLogout}>
                        {/* <li id="logoutLink" className={`nav-item`}> */}
                            <Link onClick={handleLogout} className='nav-link' to="/logout">
                            {/* <Link className='nav-link' to="/logout"> */}
                                <i className="feather" data-feather="log-out"></i>
                                <span>Logout</span>
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </aside>
    )
}

function mapStateToProps(state) {

    return { authData: state.dataSet.authData, data: state.dataSet };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setAuthData, removeFilter, setInsightFunction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminSideBar);